import { render, staticRenderFns } from "./OrderConfirmPanel.vue?vue&type=template&id=3581f8fe&scoped=true"
import script from "./OrderConfirmPanel.vue?vue&type=script&lang=js"
export * from "./OrderConfirmPanel.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirmPanel.vue?vue&type=style&index=0&id=3581f8fe&prod&lang=scss&scoped=true"
import style1 from "./OrderConfirmPanel.vue?vue&type=style&index=1&id=3581f8fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3581f8fe",
  null
  
)

export default component.exports